/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "@/src/components/Header";
import { Footer } from "@/src/components/Footer";
import { Home } from "@/src/pages/Home";
import { Workshops } from "@/src/components/Workshops";
import { FAQ } from "@/src/pages/FAQ";
import { PrivacyPolicy } from "@/src/pages/PrivacyPolicy";
import { ScrollToTop } from "@/src/components/ScrollToTop";
import { ScrollToTopButton } from "@/src/components/ScrollToTopButton";

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <ScrollToTopButton />
        <div className="min-h-screen bg-background text-foreground selection:bg-primary/20 selection:text-primary">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/workshops" element={<Workshops />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}
